import ApiClient from 'api-client/ApiClient'
import ActionsSet from 'core/actions/ActionsSet'
import CreateAction from 'core/actions/CreateAction'
import ListAction from 'core/actions/ListAction'
import DeleteAction from 'core/actions/DeleteAction'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'
import Bugsnag from 'utils/bugsnag'
import { pathStr } from 'utils/fp'
import { trackEvent } from 'utils/tracking'

const { kubernetes } = ApiClient.getInstance()

export const kaapiKubeadmConfigTemplatesActions = ActionsSet.make<
  DataKeys.KaapiKubeadmConfigTemplates
>({
  uniqueIdentifier: 'metadata.uid',
  entityName: entityNamesByKey[DataKeys.KaapiKubeadmConfigTemplates],
  cacheKey: DataKeys.KaapiKubeadmConfigTemplates,
})

export const listkaapiKubeadmConfigTemplates = kaapiKubeadmConfigTemplatesActions.add(
  new ListAction<DataKeys.KaapiKubeadmConfigTemplates, { namespace: string }>(
    async ({ namespace }) => {
      Bugsnag.leaveBreadcrumb('Attempting to list Kaapi KaapiKubeadmConfigTemplates', { namespace })
      return kubernetes.getAllCustomResources(DataKeys.KaapiKubeadmConfigTemplates)
    },
  ),
)

export const deleteKaapiKudeadmConfigTemplates = kaapiKubeadmConfigTemplatesActions.add(
  new DeleteAction<DataKeys.KaapiKubeadmConfigTemplates, { namespace: string; name: string }>(
    async ({ namespace, name }) => {
      Bugsnag.leaveBreadcrumb('Attempting to delete Kaapi KaapiKubeadmConfigTemplates', {
        namespace,
        name,
      })
      await kubernetes.deleteCustomResource({ type: DataKeys.KaapiKubeadmConfigTemplates, name })
    },
  ),
)

export const createKaapiKubeadmConfigTemplate = kaapiKubeadmConfigTemplatesActions.add(
  new CreateAction<DataKeys.KaapiKubeadmConfigTemplates, { namespace: string; body: any }>(
    async ({ namespace, body }) => {
      Bugsnag.leaveBreadcrumb('Attempting to create Kaapi KubeadmConfigTemplate', {
        namespace,
        body,
      })
      const created = await kubernetes.createCustomResource({
        type: DataKeys.KaapiKubeadmConfigTemplates,
        body,
      })
      trackEvent('Create New Kaapi KubeadmConfigTemplate', {
        namespace,
        name: pathStr('metadata.name', created),
      })
      return created
    },
  ),
)
